module.exports = __webpack_public_path__ + "img/P5-en.f5c6ad9e.png";